import { Popover as ChakraPopover, Portal } from '@chakra-ui/react';
import * as React from 'react';

const PopoverArrow = React.forwardRef<HTMLDivElement, ChakraPopover.ArrowProps>(
  function PopoverArrow(props, ref) {
    return (
      <ChakraPopover.Arrow {...props} ref={ref}>
        <ChakraPopover.ArrowTip borderColor="gray.600" />
      </ChakraPopover.Arrow>
    );
  }
);

const PopoverBody = React.forwardRef<HTMLDivElement, ChakraPopover.BodyProps>(
  (props, ref) => (
    <ChakraPopover.Body ref={ref} overflow="auto" p={3} {...props} />
  )
);

interface PopoverContentProps extends ChakraPopover.ContentProps {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
}

const PopoverContent = React.forwardRef<HTMLDivElement, PopoverContentProps>(
  function PopoverContent(props, ref) {
    const { portalled = true, portalRef, ...rest } = props;
    return (
      <Portal disabled={!portalled} container={portalRef}>
        <ChakraPopover.Positioner>
          <ChakraPopover.Content
            ref={ref}
            border="1px solid"
            borderColor="gray.500"
            borderRadius="md"
            boxShadow="sm"
            _open={{ animation: 'none' }}
            _closed={{ animation: 'none' }}
            {...rest}
          />
        </ChakraPopover.Positioner>
      </Portal>
    );
  }
);

const PopoverTitle = React.forwardRef<HTMLDivElement, ChakraPopover.TitleProps>(
  (props, ref) => (
    <ChakraPopover.Title
      fontSize="md"
      fontWeight="medium"
      mb={2}
      ref={ref}
      {...props}
    />
  )
);

export type PopoverRootProps = ChakraPopover.RootProps;

const PopoverRoot: React.FC<PopoverRootProps> = (props) => (
  <ChakraPopover.Root autoFocus={false} {...props} />
);

const PopoverTrigger = React.forwardRef<
  HTMLButtonElement,
  ChakraPopover.TriggerProps
>((props, ref) => <ChakraPopover.Trigger asChild ref={ref} {...props} />);

const Popover = {
  Arrow: PopoverArrow,
  Body: PopoverBody,
  Content: PopoverContent,
  Root: PopoverRoot,
  Title: PopoverTitle,
  Trigger: PopoverTrigger,
};

export default Popover;
